import {useContext} from 'react';
import {TestAuth0Context} from '../utils/testAuth0Provider/TestAuth0Provider';
import {Auth0Context} from '@auth0/auth0-react';
import LeadflowWindow from '../LeadflowWindow';

const useAuth = () =>
    useContext(LeadflowWindow.REACT_APP_IS_AUTH_IN_TEST_MODE === 'true' ? TestAuth0Context : (Auth0Context))

export default useAuth
